import React, {useContext} from 'react'
import CustomerDetailContext from "../../../../context/CustomerDetailContext"

function BlockLeft(props) {
    const CustomerDetailPageContext = useContext(CustomerDetailContext)
    const {customerInformation} = CustomerDetailPageContext

    return (
        <div className="BlockLeft">
            <div className="Item">
                <div className="Title">Tên khách hàng</div>
                <div className="Content">{customerInformation.name}</div>
            </div>
            <div className="Item">
                <div className="Title">Số điện thoại</div>
                <div className="Content">{customerInformation.phone}</div>
            </div>
            <div className="Item">
                <div className="Title">Nguồn khách hàng</div>
                <div className="Content">{customerInformation.source}</div>
            </div>
            <div className="Item">
                <div className="Title">Email</div>
                <div className="Content">{customerInformation.email}</div>
            </div>
            <div className="Item">
                <div className="Title">Nghề nghiệp</div>
                <div className="Content">{customerInformation.job}</div>
            </div>
            <div className="Item">
                <div className="Title">Địa chỉ</div>
                <div className="Content">{customerInformation.address}</div>
            </div>
            <div className="Item">
                <div className="Title">Số CMND/CCCD</div>
                <div className="Content">{customerInformation.identityNumber}</div>
            </div>
            <div className="Item">
                <div className="Title">Ngày cấp</div>
                <div className="Content">{customerInformation.identity_issuing_date}</div>
            </div>
            <div className="Item">
                <div className="Title">Nơi cấp</div>
                <div className="Content">{customerInformation.identity_issuing_department}</div>
            </div>
            <div className="Item">
                <div className="Title">Ngày sinh</div>
                <div className="Content">{customerInformation.date_of_birth}</div>
            </div>
            <div className="Item">
                <div className="Title">Mô tả</div>
                <div className="Content">{customerInformation.description}</div>
            </div>
        </div>
    )
}

export default BlockLeft